import React from 'react';
import PropTypes from 'prop-types';
import Error from './error-screen';
import illustrations from '../assets/illustrations';
import Text from '../text';
import Colors from '../colors';
import Spacer from '../spacer';
export default function PageNotFound(props) {
  return /*#__PURE__*/React.createElement(Error, {
    title: "The page you're looking for cannot be found",
    label: "Error 404",
    paddingBottom: 125,
    illustration: illustrations.Error404
  }, /*#__PURE__*/React.createElement(Text.BodyBase, {
    color: Colors.gray400
  }, "This might be because of a misspelled URL, the page no longer exists, or it has been moved elsewhere."), /*#__PURE__*/React.createElement(Spacer, {
    size: "f16",
    height: true
  }), /*#__PURE__*/React.createElement(Text.BodyBase, {
    color: Colors.gray400
  }, "If you have any questions or need assistance, please don't hesitate to", ' ', /*#__PURE__*/React.createElement(Text.BodyBase, {
    color: Colors.advanceBlue400,
    textDecorationLine: "underline",
    onPress: props.onPressLink
  }, "contact us."), ' ', "We're here to help!"));
}
PageNotFound.defaultProps = {
  onPressLink: () => null
};
PageNotFound.propTypes = {
  onPressLink: PropTypes.func
};
//# sourceMappingURL=404.js.map